"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Confirm = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/styles");
var useStyles = (0, styles_1.makeStyles)(function (t) { return (0, styles_1.createStyles)({
    progress: {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
    }
}); });
var enterKeyCode = 13;
var Confirm = function (_a) {
    var children = _a.children, title = _a.title, content = _a.content, confirmLabel = _a.confirmLabel, cancelLabel = _a.cancelLabel, onConfirm = _a.onConfirm, onClick = _a.onClick, confirmDisabled = _a.confirmDisabled, loading = _a.loading, PaperProps = _a.PaperProps, props = __rest(_a, ["children", "title", "content", "confirmLabel", "cancelLabel", "onConfirm", "onClick", "confirmDisabled", "loading", "PaperProps"]);
    var _b = (0, react_1.useState)(false), open = _b[0], setOpen = _b[1];
    var css = useStyles();
    var close = function () { return setOpen(false); };
    var confirm = function (event) {
        if (onConfirm)
            onConfirm(event, close);
    };
    var handleKeypress = function (e) {
        if (e.keyCode === enterKeyCode) {
            confirm(e);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.cloneElement(children, {
            onClick: function (event) {
                if (children.props.onClick)
                    children.props.onClick(event);
                if (onClick)
                    onClick(event);
                setOpen(true);
            }
        }),
        React.createElement(material_1.Dialog, __assign({ open: open }, props, { PaperProps: PaperProps }),
            loading && React.createElement(material_1.LinearProgress, { className: css.progress }),
            React.createElement(material_1.DialogTitle, null, title),
            React.createElement(material_1.DialogContent, null, (typeof content === 'function') ? content(close) : content),
            React.createElement(material_1.DialogActions, null,
                React.createElement(material_1.Button, { color: "primary", onClick: function () { return setOpen(false); } }, cancelLabel || 'Cancel'),
                onConfirm && (React.createElement(material_1.Button, { color: "primary", onClick: confirm, disabled: confirmDisabled }, confirmLabel || 'Confirm'))))));
};
exports.Confirm = Confirm;
//# sourceMappingURL=Confirm.js.map